import { isTabletOrIpad } from './isTabletOrIpad';
import Browser from './core/hooks/Browser';

const isAutoLaunchChatWindow = (options) =>
    (options.launchChatWindowEnabled || options.model?.launchChatWindowEnabled) &&
    !(options.isMobile || Browser.isiOS() || Browser.isAndroid()) &&
    !isTabletOrIpad()
export default isAutoLaunchChatWindow;
